import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex flex-column min-vh-100 login-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  href: "/",
  class: "position-absolute btn-primary btn-circle b-close"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
], -1)
const _hoisted_3 = { class: "main_content_iner" }
const _hoisted_4 = { class: "row mx-0" }
const _hoisted_5 = { class: "col-md-8 login-box min-vh-100 d-flex flex-column" }
const _hoisted_6 = { class: "mb_30 mt-auto mb-auto" }
const _hoisted_7 = { class: "row justify-content-center" }
const _hoisted_8 = { class: "col-9 mt-5" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "login-with d-flex justify-content-between mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "right-border" }),
  /*#__PURE__*/_createElementVNode("span", null, " Login with "),
  /*#__PURE__*/_createElementVNode("div", { class: "left-border" })
], -1)
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "row justify-content-center" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold text-center mb-4 mt-4" }, "Login with email", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  "data-bs-toggle": "modal",
  "data-bs-target": "#forgotPassword",
  class: "d-none"
}, "Forgot password", -1)
const _hoisted_15 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_16 = { class: "text-center mt-2" }
const _hoisted_17 = { class: "btn btn-primary rounded-5 my-3 px-5 fw-bold" }
const _hoisted_18 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Login ")
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "w-100 border-bottom my-5" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h6", { class: "text-center fw-bold" }, [
  /*#__PURE__*/_createTextVNode("Don’t have an account? "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "fw-bold text-primary text-decoration-underline",
    href: "/signup"
  }, "Sign Up")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_login_side_image = _resolveComponent("login-side-image")!
  const _component_facebook = _resolveComponent("facebook")!
  const _component_google = _resolveComponent("google")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!
  const _component_ForgotPasswordModal = _resolveComponent("ForgotPasswordModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_login_side_image),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_facebook),
                  _createVNode(_component_google)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("div", null, [
                      _createVNode(_component_Form, { onSubmit: _ctx.SignIn }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Field, {
                            name: "email",
                            rules: { required: true, email: true },
                            modelValue: _ctx.email,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event))
                          }, {
                            default: _withCtx(({ field, meta }) => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["form-group icon-addon mb-4", meta.validated && !meta.valid ? 'has-error border-danger' : ''])
                              }, [
                                _createElementVNode("input", _mergeProps(field, {
                                  type: "text",
                                  id: "email",
                                  placeholder: "Email Address",
                                  class: "form-control material-control",
                                  autocomplete: "off"
                                }), null, 16),
                                _createVNode(_component_ErrorMessage, {
                                  class: "text-danger",
                                  name: "email"
                                })
                              ], 2)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_Field, {
                            name: "password",
                            rules: { required: true, min:5 },
                            modelValue: _ctx.password,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event))
                          }, {
                            default: _withCtx(({ field, meta }) => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["form-group icon-addon mb-4", meta.validated && !meta.valid ? 'has-error border-danger' : ''])
                              }, [
                                _createElementVNode("input", _mergeProps(field, {
                                  type: "password",
                                  id: "password",
                                  placeholder: "Password",
                                  class: "form-control material-control",
                                  autocomplete: "off"
                                }), null, 16),
                                _createVNode(_component_ErrorMessage, {
                                  class: "text-danger",
                                  name: "password"
                                })
                              ], 2)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _hoisted_14,
                          (_ctx.wrong_credentials)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_15, "Incorrect username or password."))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("button", _hoisted_17, [
                              (_ctx.logging)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_18))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _hoisted_19
                                  ], 64))
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["onSubmit"])
                    ])
                  ])
                ]),
                _hoisted_20,
                _hoisted_21,
                _createVNode(_component_ForgotPasswordModal)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}